import InternalDropdownTreeSelect, {
  DropdownTreeSelectProps as InternalDropdownTreeSelectProps,
} from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import './DropdownTreeSelect.css'

// re-export everything from react-dropdown-tree-select, it is just a wrapper
export * from 'react-dropdown-tree-select'

export interface DropdownTreeSelectProps
  extends Omit<InternalDropdownTreeSelectProps, 'id' | 'value' | 'defaultValue'> {}

export const DropdownTreeSelect = ({ data, onFocus, ...rest }: DropdownTreeSelectProps) => {
  return <InternalDropdownTreeSelect data={data} {...rest} />
}
